import { U21Form, U21Modal } from 'app/shared/u21-ui/components';
import { IconBookmark } from '@u21/tabler-icons';

import { Filter, SavedFilter } from 'app/modules/filters/models';
import { useUpdateSavedFilter } from 'app/modules/filters/queries/useUpdateSavedFilter';
import { SaveFilterFormContent } from 'app/modules/filters/components/SaveFilterFormContent';

const FORM_ID = 'edit-saved-filter-form';

interface FormValues {
  title: string;
  description?: string;
}

interface Props {
  filters: Filter[];
  onClose: () => void;
  onUpdated?: (savedFilter: SavedFilter) => void;
  open: boolean;
  savedFilter: SavedFilter;
}

export const EditSavedFilterModal = ({
  filters,
  onClose,
  onUpdated,
  open,
  savedFilter,
}: Props) => {
  const { isPending, mutateAsync: updateSavedFilter } = useUpdateSavedFilter();

  return (
    <U21Modal
      title="Update Saved Filter"
      titleIcon={<IconBookmark />}
      open={open}
      onClose={onClose}
      actionButtonProps={{
        children: 'Update Filter',
        type: 'submit',
        form: FORM_ID,
        loading: isPending,
      }}
    >
      <U21Form
        id={FORM_ID}
        prompt={false}
        initialValues={{
          title: savedFilter.title,
          description: savedFilter.description ?? '',
        }}
        // default description to empty string so its clearable
        onSubmit={async ({ title, description = '' }: FormValues) => {
          try {
            const updated = await updateSavedFilter({
              id: savedFilter.id,
              title,
              description,
              filters,
            });
            onUpdated?.(updated);
            onClose();
          } catch {}
        }}
      >
        <SaveFilterFormContent />
      </U21Form>
    </U21Modal>
  );
};
